


















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ComposePatient,
  GetRenkouxueTemplate,
  GetRenkouxueContent,
  ChangeRenkouxueContent,
  PatientDetail,
} from "@/request/zhuanbingshujuku";
import RkxxxTransfer from "./rkxxx-transfer.vue";
@Component({
  components: {
    RkxxxTransfer,
  },
})
export default class ZbsjkDetailComposePatient extends Vue {
  @Prop()
  private ifShow: any;
  @Prop()
  private data: any;
  @Prop()
  private center: any;
  @Prop()
  private user: any;
  private patient: any = {};
  private templates: any[] = [];
  private get visible() {
    return this.ifShow;
  }
  private set visible(val) {
    this.$emit("update:ifShow", val);
  }
  private patientChange() {
    this.$emit("update:patient", this.patient);
  }
  private fangshiChange() {
    this.patient["身份证号"] = "";
  }
  /**
   * @description 获取人口学信息
   */
  private getRenkuoxueTemplate() {
    this.templates = [];
    const params: any = {
      params: {
        project_id: this.patient.project_id,
        group_id: this.patient.group_id,
      },
    };
    GetRenkouxueTemplate(this, params).then((templates: any) => {
      this.templates = templates;
      templates.forEach((template: any, index: any) => {
        const params2: any = {
          params: {
            project_id: template["project_id"],
            group_id: template["group_id"],
            patient_id: this.patient["patient_id"],
            type: template["名称"],
          },
        };
        GetRenkouxueContent(this, params2).then((contents: any) => {
          this.$set(this.templates[index], "contents", contents);
        });
      });
    });
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.$emit("update:patient", {});
    this.$emit("update:ifShow", false);
  }
  /**
   * @description 保存
   */
  private save() {
    // 上传人口学信息
    this.templates.forEach((template: any) => {
      const params: any = {
        project_id: template["project_id"],
        group_id: template["group_id"],
        create_time: template["create_time"],
        template_id: template["template_id"],
        patient_id: this.patient["patient_id"],
      };
      params["data"] = template["contents"]["data"];
      params["content_id"] = template["contents"]["content_id"];
      ChangeRenkouxueContent(this, params).then((d: any) => {
        console.log(d);
      });
    });
    // 修改基本信息
    if (!this.patient["姓名"]) {
      this.$message.warning("姓名必须填写");
      return;
    }
    if (!this.patient["性别"]) {
      this.$message.warning("性别必须填写");
      return;
    }
    // if (!this.patient["出生日期"]) {
    //   this.$message.warning("出生日期必须填写");
    //   return;
    // }
    // const birthdayRep: RegExp = /\d{4}-[0-1]\d-\d{2}/g;
    // if (!birthdayRep.test(this.patient["出生日期"])) {
    //   this.$message.warning("出生日期格式不对，请重新输入");
    //   return;
    // }
    if (!this.patient["认证方式"]) {
      this.$message.warning("认证方式必须填写");
      return;
    }
    if (!this.patient["身份证号"]) {
      this.$message.warning("认证号码必须填写");
      return;
    }
    // 验证手机号格式
    const shoujiRep: RegExp = /^\d{11}$/;
    if (this.patient["认证方式"] === "联系方式") {
      if (!shoujiRep.test(this.patient["身份证号"])) {
        this.$message.warning("认证号码格式错误，请输入11位数！");
        return;
      }
    }
    // 验证身份证格式
    const shenfenzhengRep: RegExp = /^[a-zA-Z0-9]{18}$/;
    if (this.patient["认证方式"] === "身份证号") {
      if (!shenfenzhengRep.test(this.patient["身份证号"])) {
        this.$message.warning("认证号码格式错误，请输入18位数字或字母！");
        return;
      }
    }

    this.patient.group_id = this.center.group_id;
    this.patient.project_id = this.center.project_id;
    ComposePatient(this, this.patient).then((data: any) => {
      localStorage.setItem("patient", JSON.stringify(this.patient));
      this.$emit("change");
      this.$emit("update:ifShow", false);
    });
  }
  /**
   * @description 获取患者信息
   */
  private getPatient() {
    console.log('获取患者信息');
    console.log(this.data);
    const params: any = {
      params: {
        project_id: this.data.project_id,
        group_id: this.data.group_id,
        patient_id: this.data.patient_id,
      },
    };
    PatientDetail(this, params).then((res) => {
      this.patient = res;
      this.getRenkuoxueTemplate();
    });
  }
  /**
   * @description 隐藏或者显示某些相关题目
   */
  private changeHide(e) {
    let arr = [];
    if (e.control.index.length === 0) {
      // 循环改值
      e.control.all.forEach((ele) => {
        const index = this.templates[0]["contents"].data.findIndex((val) => {
          return ele === val.id;
        });
        this.$set(
          this.templates[0]["contents"].data[index],
          "hide",
          !e.control.hide
        );
        // 如果是隐藏需要清除值
        if (!e.control.hide) {
          this.clearVal(this.templates[0]["contents"].data[index]);
        }
      });
    } else {
      // 拼接数组
      e.control.index.forEach((ele) => {
        arr = arr.concat(e.control.list[ele]);
      });
      // 去重
      arr = Array.from(new Set(arr));
      e.control.all.forEach((ele) => {
        const index = this.templates[0]["contents"].data.findIndex((val) => {
          return ele === val.id;
        });
        const i = arr.findIndex((val) => {
          return ele === val;
        });
        if (i === -1) {
          // 找不到给hide相反的值
          this.$set(
            this.templates[0]["contents"].data[index],
            "hide",
            !e.control.hide
          );
          // 如果是隐藏需要清除值
          if (!e.control.hide) {
            this.clearVal(this.templates[0]["contents"].data[index]);
          }
        } else {
          // 找到给hide的值
          this.$set(
            this.templates[0]["contents"].data[index],
            "hide",
            e.control.hide
          );
          // 如果是隐藏需要清除值
          if (e.control.hide) {
            this.clearVal(this.templates[0]["contents"].data[index]);
          }
        }
      });
    }
  }
  /**
   * @description 清除隐藏题目的value
   */
  private clearVal(item) {
    if (item.type === "单选" || item.type === "下拉单选") {
      item.value = "";
    } else if (item.type === "计分单选" || item.type === "sf36计分单选") {
      item.value = {};
    } else if (item.type === "单选补充文字" || item.type === "多选补充文字") {
      item.options.forEach((ele) => {
        ele.value = false;
        if (ele.content) {
          ele.content = "";
        }
      });
    } else if (item.type === "多选") {
      item.value = [];
    }
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getPatient();
  }
}
